import { render, staticRenderFns } from "./QuestionsView.vue?vue&type=template&id=032bf418&"
import script from "./QuestionsView.vue?vue&type=script&lang=ts&"
export * from "./QuestionsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports